import React, { Component } from 'react';
import Button from '../CommonComponents/Button';
import Input from '../CommonComponents/Input';
import SearchOptions from '../CommonComponents/SearchOptions';
import { queues } from '../constants';
import { api } from '../utils';

type Props = {
  comment: string;
  setComment: Function;
  onTransfer: Function;
  onOptionSelect: Function;
  transferTypeIndex: number;
  chatBotId: string;
  queueName: string;
  tenantId: number;
};
type State = { queueData: any };

export default class Transfer extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
  }
  setInitialState(): State {
    return {
      queueData: [],
    };
  }
  get isDisabled(): boolean {
    return (
      this.props.transferTypeIndex < 0
      // ||
      // !new RegExp('^\\s*\\w+[\\w,;\'"\\s.?!]*$').test(this.props.comment)
    );
  }
  componentDidMount() {
    api(
      `listOfQueues?botId=${encodeURIComponent(this.props.chatBotId)}&tenantId=${
        this.props.tenantId
      }&agentSessionID=${sessionStorage.getItem('agentActiveSession')}`
    ).then((res) => {
      this.setState({
        queueData: res.JsonResp,
      });
    });
  }
  get fetchQueueList() {
    return this.state.queueData.filter((data: any) => {
      return data.queueName !== this.props.queueName && data.queueName !== 'No Queue';
    });
  }

  render() {
    return (
      <div id='transfer-content-wrapper'>
        <SearchOptions
          placeholder='Search queue'
          onSelect={this.props.onOptionSelect}
          options={this.fetchQueueList}
        />
        <Input
          label='Add comment'
          value={this.props.comment}
          onValueChange={this.props.setComment}
        />
        <Button
          text='Transfer'
          theme='dark'
          disabled={this.isDisabled}
          onClick={() => {
            if (!this.isDisabled) {
              this.props.onTransfer();
            }
          }}
        />
      </div>
    );
  }
}
